import { useMaskPII } from 'hooks/useMaskPII';
import { NsSortCodeInput } from 'components/common/ns-sortcode-input/NsSortCodeInput';
import { NsFirstNameInput } from 'components/common/ns-first-name-input/NsFirstNameInput';
import { NsLastNameInput } from 'components/common/ns-last-name-input/NsLastNameInput';
import {
  DateString,
  NsDatepicker
} from 'components/common/ns-datepicker/NsDatepicker';
import { NsBankAccountInput } from 'components/common/ns-bank-account-input/NsBankAccountInput';
import { DirectDebitAddress } from 'components/direct-sales/direct-debit-revamp/components/DirectDebitAddress';
import { PaymentDate } from 'components/direct-sales/direct-debit-revamp/components/PaymentDate';
import { NsAccountHolderNameInput } from 'components/common/ns-account-holder-name/NsAccountHolderNameInput';
import NsInputterEvent from 'components/common/ns-inputter/NsInputterEvent';

type DirectDebitFormProps = {
  handleChange: (event: NsInputterEvent) => void;
  details: {
    firstName?: string;
    lastName?: string;
    accountHolderName?: string;
    birthDate?: string;
    paymentDate?: string;
    sortCode?: string;
    accountNumber?: string;
  };
};

export const DirectDebitForm = ({
  handleChange,
  details
}: DirectDebitFormProps) => {
  const {
    firstName,
    lastName,
    accountHolderName,
    birthDate,
    paymentDate,
    sortCode,
    accountNumber
  } = details;
  const { mask } = useMaskPII();

  return (
    <>
      <NsFirstNameInput
        id="firstName"
        name="firstName"
        value={firstName}
        label="First name"
        inputAttributes={mask}
        onChange={handleChange}
      />
      <NsLastNameInput
        id="lastName"
        name="lastName"
        value={lastName}
        label="Last name"
        inputAttributes={mask}
        onChange={handleChange}
      />
      <NsAccountHolderNameInput
        label="Name of account holder"
        value={accountHolderName}
        tipDetail={
          <>
            Please separate names or initials with a single space, and
            don&apos;t include any extra spaces at the start or end of your
            name.
          </>
        }
        helper="Good to know"
        inputAttributes={mask}
        onChange={handleChange}
      />
      <NsBankAccountInput
        id="accountNumber"
        name="accountNumber"
        label="Account number"
        value={accountNumber}
        inputAttributes={mask}
        onChange={handleChange}
      />
      <NsSortCodeInput
        id="sortCode"
        name="sortCode"
        label="Sort code"
        value={sortCode}
        inputAttributes={mask}
        onChange={handleChange}
      />
      <NsDatepicker
        name="birthDate"
        value={(birthDate as DateString) ?? ('' as DateString)}
        label="Date of birth"
        isBirthDate
        onChange={handleChange}
      />
      <PaymentDate handleChange={handleChange} value={paymentDate || ''} />
      <DirectDebitAddress />
    </>
  );
};
